// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__jc7u4","topBottomGutter":"Layout_topBottomGutter__3JKjP"};